

export default {
  path: 'test',
  priority: 7000000,
  permissions: ['Dashboard'],
  name: 'TEST',
  icon: 'test-tube',
  drawer: false,
};


